(ns machtfit.stepchall.icons)

(defn eye []
  [:svg {:version "1.1", :viewBox "0 0 22 20", :height "20px", :width "22px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero"
      :fill "#000000"
      :transform "translate(-14.000000, -18.000000)"}
     [:g
      {:transform "translate(14.000000, 18.000000)"}
      [:path
       {:d
        "M8.04881395,7.14658835 C7.85386268,6.95113722 7.53694191,6.95113722
        7.34199065,7.14658835 C7.14653951,7.34153962 7.14653951,7.65846038
        7.34199065,7.85341165 C7.53694191,8.04886278 7.85386268,8.04886278
        8.04881395,7.85341165 C8.24426508,7.65846038 8.24426508,7.34153962
        8.04881395,7.14658835 Z"}]
      [:path
       {:d
        "M10.6954023,8 C9.8683023,8 9.1954023,8.6729 9.1954023,9.5
        C9.1954023,10.3271 9.8683023,11 10.6954023,11 C11.5225023,11
        12.1954023,10.3271 12.1954023,9.5 C12.1954023,8.6729 11.5225023,8
        10.6954023,8 Z M10.6954023,10 C10.4197023,10 10.1954023,9.7757
        10.1954023,9.5 C10.1954023,9.2243 10.4197023,9 10.6954023,9
        C10.9711023,9 11.1954023,9.2243 11.1954023,9.5 C11.1954023,9.7757
        10.9711023,10 10.6954023,10 Z"}]
      [:path
       {:d
        "M10.6954023,6 C10.2063648,6 9.73347105,6.09883125 9.2899773,6.29378125
        C9.0687773,6.3910375 8.96828355,6.6491625 9.06549605,6.8703625
        C9.16270855,7.0915625 9.4208773,7.1920125 9.6420773,7.09484375
        C9.97392105,6.94898125 10.3283398,6.875 10.6954023,6.875
        C12.1428273,6.875 13.3204023,8.052575 13.3204023,9.5
        C13.3204023,10.947425 12.1428273,12.125 10.6954023,12.125
        C9.2479773,12.125 8.0704023,10.947425 8.0704023,9.5 C8.0704023,9.4850375
        8.07035855,9.470425 8.07070855,9.4554625 C8.07630855,9.21391875
        7.88503355,9.01354375 7.6434898,9.00794375 C7.4015523,9.00190625
        7.20157105,9.193575 7.19597105,9.4351625 C7.1954023,9.45695
        7.1954023,9.4782125 7.1954023,9.5 C7.1954023,11.4299 8.7655023,13
        10.6954023,13 C12.6253023,13 14.1954023,11.4299 14.1954023,9.5
        C14.1954023,7.5701 12.6253023,6 10.6954023,6 Z"}]
      [:path
       {:d
        "M10.6954023,0 C10.4192523,0 10.1954023,0.1678875 10.1954023,0.375
        L10.1954023,2.625 C10.1954023,2.8321125 10.4192523,3 10.6954023,3
        C10.9715523,3 11.1954023,2.8321125 11.1954023,2.625 L11.1954023,0.375
        C11.1954023,0.1678875 10.9715523,0 10.6954023,0 Z"}]
      [:path
       {:d
        "M6.05464325,3.17949925 L4.01588996,1.1407582 C3.82821123,0.9530806
        3.52388813,0.9530806 3.33616134,1.1407582 C3.14848262,1.3284358
        3.14848262,1.63275707 3.33616134,1.82048273 L5.37491464,3.85922378
        C5.56259337,4.04690138 5.86696453,4.04694944 6.05464325,3.85922378
        C6.24232198,3.67154618 6.24232198,3.36722491 6.05464325,3.17949925 Z"}]
      [:path
       {:d
        "M18.0546433,1.1407582 C17.8669645,0.9530806 17.5626414,0.9530806
        17.3749146,1.1407582 L15.3361613,3.17949925 C15.1484826,3.36717685
        15.1484826,3.67149812 15.3361613,3.85922378 C15.523792,4.04690138
        15.8281632,4.04694944 16.01589,3.85922378 L18.0546433,1.82048273
        C18.242322,1.63280513 18.242322,1.32848386 18.0546433,1.1407582 Z"}]
      [:path
       {:d
        "M21.0926617,9.57234615 C18.4871433,6.52961923 14.6183841,4 10.6954023,4
        C6.77188727,4 2.90316914,6.53025385 0.298142848,9.57234615
        C0.148189671,9.7475 0.164267802,10.0148423 0.334031532,10.1695192
        C0.503836278,10.3241962 0.763055118,10.3076115 0.912967279,10.1325
        C1.00037161,10.0304115 1.08990875,9.92870385 1.18059432,9.82763077
        C3.20738213,12.9864923 6.88148106,15 10.6954023,15 C14.5093235,15
        18.1834225,12.9864923 20.2102103,9.82763077 C20.3008959,9.92874615
        20.390433,10.0304538 20.4778373,10.1325 C20.6272983,10.3070615
        20.8864761,10.3246615 21.0567731,10.1695192 C21.2265368,10.0148423
        21.2426149,9.74745769 21.0926617,9.57234615 Z M10.6954023,14.1538462
        C7.08951238,14.1538462 3.621394,12.2212731 1.76674882,9.20469231
        C3.22805402,7.72768846 6.60454346,4.84615385 10.6954023,4.84615385
        C14.7863021,4.84615385 18.1627506,7.72768846 19.6240558,9.20465
        C17.7694106,12.2212731 14.3012922,14.1538462 10.6954023,14.1538462
        Z"}]]]]])

(defn like []
  [:svg {:version "1.1", :viewBox "0 0 17 25", :height "25", :width "17px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero", :fill "#FFFFFF"}
     [:path
      {:d
       "M16.338684,11.3855899 C16.5925507,11.1016231 16.7472173,10.7268013
       16.7472173,10.3167063 C16.7472173,9.43273951 16.0293507,8.71338084
       15.1472173,8.71338084 L12.0417951,8.71338084 C12.3493507,7.77810768
       12.4805507,6.53713381 12.4805507,6.00518606 L12.4805507,5.47110055
       C12.4805507,4.29247823 11.5233951,3.33333333 10.3472173,3.33333333
       L9.81388401,3.33333333 C9.56926179,3.33333333 9.35592845,3.50007918
       9.29655067,3.73808393 L9.00606179,4.90281077 C8.59895067,6.53392716
       7.30650623,8.33357086 5.96890623,8.66064925 C5.73459512,8.06634996
       5.15610623,7.64449723 4.48055067,7.64449723 L1.28055067,7.64449723
       C0.986150674,7.64449723 0.747217341,7.88392716 0.747217341,8.17893903
       L0.747217341,17.7988915 C0.747217341,18.0939034 0.986150674,18.3333333
       1.28055067,18.3333333 L4.48055067,18.3333333 C5.11663956,18.3333333
       5.66703956,17.9595804 5.92481734,17.4194378 L7.75735067,18.0315519
       C8.35646179,18.2317894 8.98081734,18.3333333 9.61263956,18.3333333
       L14.0805507,18.3333333 C14.962684,18.3333333 15.6805507,17.6139747
       15.6805507,16.7300079 C15.6805507,16.5215756 15.6407285,16.3220507
       15.5681951,16.1392716 C16.2465951,15.9536421 16.7472173,15.330483
       16.7472173,14.5922407 C16.7472173,14.1821457 16.5925507,13.8073238
       16.338684,13.5233571 C16.5925507,13.2393903 16.7472173,12.8645685
       16.7472173,12.4544735 C16.7472173,12.0443785 16.5925507,11.6695566
       16.338684,11.3855899 Z M5.01388401,16.7300079 C5.01388401,17.0246635
       4.77459512,17.2644497 4.48055067,17.2644497 L1.81388401,17.2644497
       L1.81388401,8.71338084 L4.48055067,8.71338084 C4.77459512,8.71338084
       5.01388401,8.95316706 5.01388401,9.24782264 L5.01388401,16.7300079 Z
       M14.0805507,11.9200317 L15.1472173,11.9200317 C15.4412618,11.9200317
       15.6805507,12.1598179 15.6805507,12.4544735 C15.6805507,12.7491291
       15.4412618,12.9889153 15.1472173,12.9889153 L14.0805507,12.9889153
       C13.7861507,12.9889153 13.5472173,13.2283452 13.5472173,13.5233571
       C13.5472173,13.818369 13.7861507,14.0577989 14.0805507,14.0577989
       L15.1472173,14.0577989 C15.4412618,14.0577989 15.6805507,14.2975851
       15.6805507,14.5922407 C15.6805507,14.8868963 15.4412618,15.1266825
       15.1472173,15.1266825 L14.0805507,15.1266825 C13.7861507,15.1266825
       13.5472173,15.3661124 13.5472173,15.6611243 C13.5472173,15.9561362
       13.7861507,16.1955661 14.0805507,16.1955661 C14.3745951,16.1955661
       14.613884,16.4353523 14.613884,16.7300079 C14.613884,17.0246635
       14.3745951,17.2644497 14.0805507,17.2644497 L9.61263956,17.2644497
       C9.09566179,17.2644497 8.58472845,17.1814331 8.09441734,17.0175376
       L6.08055067,16.3448535 L6.08055067,9.73167063 C6.9171729,9.57240697
       7.73601734,9.04152811 8.47521734,8.17252573 C9.19699512,7.32383215
       9.78223956,6.198654 10.0407285,5.16219319 L10.2302396,4.40221694
       L10.3472173,4.40221694 C10.9353062,4.40221694 11.413884,4.88178939
       11.413884,5.47110055 L11.413884,6.00518606 C11.413884,6.72276326
       11.189884,8.09912906 10.9033062,8.71338084 L9.81388401,8.71338084
       C9.51948401,8.71338084 9.28055067,8.95281077 9.28055067,9.24782264
       C9.28055067,9.54283452 9.51948401,9.78226445 9.81388401,9.78226445
       L15.1472173,9.78226445 C15.4412618,9.78226445 15.6805507,10.0220507
       15.6805507,10.3167063 C15.6805507,10.6113618 15.4412618,10.8511481
       15.1472173,10.8511481 L14.0805507,10.8511481 C13.7861507,10.8511481
       13.5472173,11.090578 13.5472173,11.3855899 C13.5472173,11.6806017
       13.7861507,11.9200317 14.0805507,11.9200317 Z"}]
     [:circle {:r "1", :cy "15.8333333", :cx "4.24721734"}]
     [:path
      {:d
       "M11.2472173,0.333333333 C10.971084,0.333333333 10.7472173,0.553530055
       10.7472173,0.825136612 L10.7472173,1.84153005 C10.7472173,2.11313661
       10.971084,2.33333333 11.2472173,2.33333333 C11.5233507,2.33333333
       11.7472173,2.11313661 11.7472173,1.84153005 L11.7472173,0.825136612
       C11.7472173,0.553530055 11.5233507,0.333333333 11.2472173,0.333333333
       Z"}]
     [:path
      {:d
       "M8.57563981,2.33333333 L7.74721734,1.50491212 C7.51848635,1.2761404
       7.14756491,1.2761404 6.91879487,1.50491212 C6.69002483,1.73368383
       6.69002483,2.10456894 6.91879487,2.33333333 L7.74721734,3.16176919
       C7.97594833,3.39050185 8.34690883,3.39054091 8.57563981,3.16176919
       C8.80440985,2.93299748 8.80440985,2.56211237 8.57563981,2.33333333 Z"}]
     [:path
      {:d
       "M15.5756398,1.50491254 C15.3469088,1.27614027 14.9759874,1.27614027
       14.7472173,1.50491254 L13.9187949,2.33330404 C13.6900248,2.56207632
       13.6900248,2.93296233 13.9187949,3.1617346 C14.1475259,3.39050687
       14.5184473,3.39054593 14.7472173,3.16177365 L15.5756398,2.33333333
       C15.8044099,2.10457082 15.8044099,1.73368481 15.5756398,1.50491254
       Z"}]]]])

(defn close []
  [:svg
   {:version "1.1", :viewBox "0 0 15 15", :height "15px", :width "15px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:polygon
     {:points
      "15 1.17851562 13.8214844 0 7.5 6.32172852 1.17851562 0 0 1.17851562
      6.32148437 7.5 0 13.8214844 1.17851562 15 7.5 8.67851563 13.8214844 15 15
      13.8214844 8.67851563 7.5"
      :fill-rule "nonzero"
      :fill "#000000"}]]])

(defn search []
  [:svg
   {:version "1.1", :viewBox "0 0 16 16", :height "16px", :width "16px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:path
     {:fill-rule "nonzero"
      :fill "#535353"
      :d
      "M15.8616101,15.1840355 L11.9724994,11.2957871 C13.0157463,10.0966741
      13.6473719,8.53215078 13.6473719,6.82217295 C13.6473719,3.05809313
      10.5850521,0 6.82368596,0 C3.05877135,0 0,3.0616408 0,6.82217295
      C0,10.5827051 3.0623198,13.6443459 6.82368596,13.6443459
      C8.53404303,13.6443459 10.0989133,13.0128603 11.2982923,11.9698448
      L15.187403,15.8580931 C15.2796629,15.9503326 15.4038589,16 15.5245065,16
      C15.6451541,16 15.7693502,15.9538803 15.8616101,15.8580931
      C16.04613,15.6736142 16.04613,15.3685144 15.8616101,15.1840355 Z
      M0.954535374,6.82217295 C0.954535374,3.58669623 3.58749168,0.957871397
      6.8201375,0.957871397 C10.0563318,0.957871397 12.6857396,3.5902439
      12.6857396,6.82217295 C12.6857396,10.054102 10.0563318,12.6900222
      6.8201375,12.6900222 C3.58749168,12.6900222 0.954535374,10.0576497
      0.954535374,6.82217295 Z"}]]])

(defn locker []
  [:svg
   {:version "1.1", :viewBox "0 0 16 20", :height "20px", :width "16px"}
   [:g
    {:stroke-linejoin "round"
     :stroke-linecap "round"
     :fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:stroke "#000000"
      :transform "translate(-58.000000, -417.000000)"}
     [:g
      {:transform "translate(38.000000, 403.000000)"}
      [:g#message
       {:transform "translate(16.000000, 8.000000)"}
       [:g
        {:transform "translate(0.000000, 4.000000)"}
        [:g
         {:transform "translate(5.000000, 2.000000)"}
         [:polygon
          {:points
           "0.125 8.125 13.875 8.125 13.875 19.375 0.125 19.375"
           :stroke-width "1.25"}]
         [:path
          {:stroke-width "1.25"
           :d
           "M2.625,8.125 L2.625,5 C2.625,2.58375422 4.58375422,0.625 7,0.625
           C9.41624578,0.625 11.375,2.58375422 11.375,5 L11.375,8.125"}]
         [:path
          {:stroke-width "1.25"
           :d
           "M5.125,13.75 C5.125,14.7855339 5.96446609,15.625 7,15.625
           C8.03553391,15.625 8.875,14.7855339 8.875,13.75 C8.875,12.7144661
           8.03553391,11.875 7,11.875 C5.96446609,11.875 5.125,12.7144661
           5.125,13.75 Z"}]]]]]]]])

(defn plus []
  [:svg
   {:version "1.1", :viewBox "0 0 8 8", :height "9px", :width "8px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero", :fill "#2C2C2C"}
     [:polygon
      {:points
       "4.47058824 3.52941176 8 3.52941176 8 4.47058824 4.47058824 4.47058824
       4.47058824 8 3.52941176 8 3.52941176 4.47058824 0 4.47058824 0 3.52941176
       3.52941176 3.52941176 3.52941176 -6.39488462e-14 4.47058824
       -6.39488462e-14"}]]]])

(defn plus-circle []
  [:svg
   {:version "1.1", :viewBox "0 0 21 21", :height "21px", :width "21px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:transform "translate(1.000000, 1.000000)"}
     [:circle {:r "9.5", :cy "9.5", :cx "9.5", :stroke "#202020"}]
     [:polygon
      {:points
       "9.92 9.338 13.07 9.338 13.07 10.178 9.92 10.178 9.92 13.328 9.08 13.328
       9.08 10.178 5.93 10.178 5.93 9.338 9.08 9.338 9.08 6.188 9.92 6.188"
       :fill-rule "nonzero"
       :fill "#2C2C2C"}]]]])

(defn back []
  [:svg
   {:version "1.1", :viewBox "0 0 7 11", :height "11px", :width "7px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero", :fill "#171717"}
     [:path
      {:d
       "M2.35225747,5.5023252 L6.80974267,1.38707317 C6.93247996,1.27403252
       7,1.12289431 7,0.961739837 C7,0.800495935 6.93247996,0.649447154
       6.80974267,0.536227642 L6.41915327,0.175821138 C6.29660973,0.0624227642
       6.13279855,0 5.95823454,0 C5.78367053,0 5.6200531,0.0624227642
       5.49741268,0.175821138 L0.190066184,5.07538211 C0.0669414025,5.18895935
       -0.000481766508,5.34072358 0,5.50205691 C-0.000481766508,5.66410569
       0.0668445301,5.81569106 0.190066184,5.92935772 L5.49247219,10.8241789
       C5.61511261,10.9375772 5.77873004,11 5.95339092,11 C6.12795493,11
       6.29157236,10.9375772 6.41430966,10.8241789 L6.80480218,10.4637724
       C7.0588984,10.2291951 7.0588984,9.8473252 6.80480218,9.6128374
       L2.35225747,5.5023252 Z"}]]]])

(defn route []
  [:svg
   {:version "1.1"
    :viewBox "0 0 24 24"
    :height "24px"
    :width "24px"}
   [:g
    {:stroke-linecap "round"
     :fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g.icon-color
     {:stroke-width "1.25"
      :stroke "#000000"}
     [:g
      {:transform "translate(2.000000, 2.000000)"}
      [:path
       {:d
        "M19.375,10 C19.375,15.1776695 15.1776695,19.375 10,19.375 C4.82233047,19.375
        0.625,15.1776695 0.625,10 C0.625,4.82233047 4.82233047,0.625 10,0.625"}]
      [:path
       {:d
        "M3.32083333,11.06 C3.55032215,10.9035903 3.79002478,10.7627197 4.03833333,10.6383333"}]
      [:path
       {:stroke-dasharray "1.68750007947286"
        :d
        "M5.63166667,10.0891667 C9.0375,9.43833333 11.0541667,12.5391667 14.2341667,13.06"}]
      [:path
       {:d
        "M15.0758333,13.1333333 C15.3545329,13.1356442 15.6330354,13.11782 15.9091667,13.08"}]
      [:path
       {:stroke-linejoin "round"
        :d
        "M15.625,4.0625 C15.797589,4.0625 15.9375,4.20241102 15.9375,4.375"}]
      [:path
       {:stroke-linejoin "round"
        :d
        "M15.3125,4.375 C15.3125,4.20241102 15.452411,4.0625 15.625,4.0625"}]
      [:path
       {:stroke-linejoin "round"
        :d
        "M15.625,4.6875 C15.452411,4.6875 15.3125,4.54758898 15.3125,4.375"}]
      [:path
       {:stroke-linejoin "round"
        :d
        "M15.9375,4.375 C15.9375,4.54758898 15.797589,4.6875 15.625,4.6875"}]
      [:path
       {:stroke-linejoin "round"
        :d
        "M15.625,0.625 C17.6960678,0.625 19.375,2.30393219 19.375,4.375 C19.375,5.97583333
        17.135,9.0225 16.1175,10.3233333 C15.9990525,10.4749338 15.8173863,10.5635363
        15.625,10.5635363 C15.4326137,10.5635363 15.2509475,10.4749338 15.1325,10.3233333
        C14.115,9.02166667 11.875,5.97583333 11.875,4.375 C11.875,2.30393219 13.5539322,0.625
        15.625,0.625 L15.625,0.625 Z"}]]]]])

(defn my-steps []
  [:svg
   {:version "1.1"
    :viewBox "0 0 24 24"
    :height "24px"
    :width "24px"}
   [:g
    {:stroke-linejoin "round"
     :stroke-linecap "round"
     :fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     [:g
      {:transform "translate(3.000000, 2.000000)"}
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M7.4375,2.8125 C7.4375,4.02062289 8.41687711,5 9.625,5 C10.8331229,5
                      11.8125,4.02062289 11.8125,2.8125 C11.8125,2.03098151 11.3955649,1.30882863
                      10.71875,0.918069375 C10.0419352,0.527310121 9.20806485,0.527310121
                      8.53124998,0.918069375 C7.85443512,1.30882863 7.4375,2.03098151
                      7.4375,2.8125 L7.4375,2.8125 Z"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M16.12,4.39916667 C15.7947487,4.33277735 15.4564527,4.3990288
                      15.1802712,4.58320195 C14.9040897,4.7673751 14.7128957,5.05421699
                      14.6491667,5.38 C14.4332085,6.47786369 13.3812759,7.20330897
                      12.2783333,7.015 L5.48916667,6.04166667 C3.40943749,5.70986061
                      1.42217735,7.02637065 0.916666667,9.07083333 C0.835977412,9.39240932
                      0.886348258,9.73286842 1.0566967,10.0173034 C1.22704515,10.3017385
                      1.50341505,10.5068465 1.825,10.5875 C1.92479772,10.612171
                      2.02719832,10.6247612 2.13,10.625 C2.69980767,10.6208501
                      3.19469157,10.2318659 3.33333333,9.67916667 C3.52338888,8.87900094
                      4.30558033,8.36680823 5.115,8.5125 L6.72333333,8.74333333
                      L5.66666667,12.4233333 C5.55229537,12.9278842 5.13744055,13.3088869
                      4.625,13.38 L1.94666667,13.7625 C1.2632143,13.8603004 0.788449595,14.493631
                      0.886250018,15.1770833 C0.984050442,15.8605357 1.61738096,16.3353004
                      2.30083333,16.2375 L4.97916667,15.8558333 C6.29285843,15.6747905
                      7.41144721,14.8094312 7.91666667,13.5833333 L8.46916667,13.7416667
                      C9.06357669,13.9077027 9.44540557,14.4855963 9.365,15.0975
                      L9.00666667,17.9725 C8.93976378,18.4211749 9.12119187,18.8708806
                      9.4807136,19.1475199 C9.84023532,19.4241592 10.3214148,19.4843067
                      10.7379701,19.304677 C11.1545255,19.1250473 11.4410679,18.7338379
                      11.4866667,18.2825 L11.8458333,15.4091667 C12.0866478,13.571634
                      10.9421385,11.8358837 9.15833333,11.3333333 L8.62583333,11.1816667
                      L9.22583333,9.10333333 L11.9075,9.4875 C14.3295944,9.87257299
                      16.6230175,8.27468421 17.1008333,5.86916667 C17.2356708,5.19243576
                      16.7966416,4.5344515 16.12,4.39916667 Z"}]]]]])

(defn my-team []
  [:svg
   {:version "1.1"
    :viewBox "0 0 24 24"
    :height "24px"
    :width "24px"}
   [:title "9F219864-D833-4C60-910C-4CD0D48358A1@1.5x"]
   [:g
    {:stroke-linejoin "round"
     :stroke-linecap "round"
     :fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     [:g
      {:transform "translate(2.000000, 2.000000)"}
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M1.56166667,14.6875 C1.56166667,15.8956229 2.54104378,16.875
                      3.74916667,16.875 C4.95728956,16.875 5.93666667,15.8956229
                      5.93666667,14.6875 C5.93666667,13.4793771 4.95728956,12.5
                      3.74916667,12.5 C2.54104378,12.5 1.56166667,13.4793771
                      1.56166667,14.6875 L1.56166667,14.6875 Z"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M6.87416667,19.375 C6.25864674,18.2209001 5.0571465,17.5
                      3.74916667,17.5 C2.44118683,17.5 1.23968659,18.2209001 0.624166667,19.375"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M14.0616667,14.6875 C14.0616667,15.4690185 14.4786018,16.1911714
                      15.1554166,16.5819306 C15.8322315,16.9726899 16.6661018,16.9726899
                      17.3429167,16.5819306 C18.0197316,16.1911714 18.4366667,15.4690185
                      18.4366667,14.6875 C18.4366667,13.9059815 18.0197316,13.1838286
                      17.3429167,12.7930694 C16.6661018,12.4023101 15.8322315,12.4023101
                      15.1554166,12.7930694 C14.4786018,13.1838286 14.0616667,13.9059815
                      14.0616667,14.6875 L14.0616667,14.6875 Z"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M19.3741667,19.375 C18.7586467,18.2209001 17.5571465,17.5
                      16.2491667,17.5 C14.9411868,17.5 13.7396866,18.2209001 13.1241667,19.375"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M7.81166667,2.8125 C7.81166667,3.59401849 8.22860179,4.31617136
                      8.90541665,4.70693061 C9.58223152,5.09768986 10.4161018,5.09768986
                      11.0929167,4.70693061 C11.7697315,4.31617136 12.1866667,3.59401849
                      12.1866667,2.8125 C12.1866667,2.03098151 11.7697315,1.30882864
                      11.0929167,0.918069391 C10.4161018,0.527310142 9.58223152,0.527310142
                      8.90541665,0.918069391 C8.22860179,1.30882864 7.81166667,2.03098151
                      7.81166667,2.8125 L7.81166667,2.8125 Z"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M12.7066667,6.875 C12.0307536,6.08139012 11.0407704,5.62417224
                      9.99833333,5.62417224 C8.95589623,5.62417224
                      7.96591307,6.08139012 7.29,6.875"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M7.54166667,16.4225 C9.13768049,17.0309858
                      10.9027007,17.0256409 12.495,16.4075"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M5.29,5 C3.90715168,6.29514487 3.12272611,8.10535773 3.12333298,10
                      C3.12333298,10.2108333 3.13583333,10.4166667 3.155,10.625"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M16.8425,10.625 C16.8608333,10.4183333 16.8741675,10.2083333
                      16.8741675,10 C16.8750741,8.10529555 16.0905989,6.29496837 14.7075,5"}]]]]])

(defn leaderboard []
  [:svg
   {:version "1.1"
    :viewBox "0 0 24 24"
    :height "24px"
    :width "24px"}
   [:g
    {:stroke-linejoin "round"
     :stroke-linecap "round"
     :fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     [:g
      {:transform "translate(2.000000, 5.000000)"}
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M6.875,4 L1.875,4 C1.18464406,4 0.625,4.7163444
                      0.625,5.6 L0.625,12 L6.875,12 L6.875,4 Z"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M18.125,6 L13.125,6 L13.125,12 L19.375,12 L19.375,7.5
                      C19.375,6.67157288 18.8153559,6 18.125,6 Z"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M11.875,0 L8.125,0 C7.43464406,0 6.875,0.671572875
                      6.875,1.5 L6.875,12 L13.125,12 L13.125,1.5 C13.125,0.671572875
                      12.5653559,0 11.875,0 Z"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M3.75,7.5625 C3.57741102,7.5625 3.4375,7.70241102 3.4375,7.875
                      C3.4375,8.04758898 3.57741102,8.1875 3.75,8.1875 C3.92258898,8.1875
                      4.0625,8.04758898 4.0625,7.875 C4.0625,7.70241102 3.92258898,7.5625
                      3.75,7.5625"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M16.25,9.1875 C16.077411,9.1875 15.9375,9.32741102 15.9375,9.5
                      C15.9375,9.67258898 16.077411,9.8125 16.25,9.8125 C16.422589,9.8125
                      16.5625,9.67258898 16.5625,9.5 C16.5625,9.32741102 16.422589,9.1875 16.25,9.1875"}]
      [:path.icon-color
       {:stroke-width "1.25"
        :stroke "#000000"
        :d "M10,5.375 C9.82741102,5.375 9.6875,5.51491102 9.6875,5.6875
                      C9.6875,5.86008898 9.82741102,6 10,6 C10.172589,6 10.3125,5.86008898
                      10.3125,5.6875 C10.3125,5.51491102 10.172589,5.375 10,5.375"}]]]]])

(defn undo []
  [:svg
   {:version "1.1", :viewBox "0 0 15 13", :height "13px", :width "15px"}
   [:g
    {:opacity "0.900000036"
     :fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero", :fill "#000000"}
     [:g
      {:transform "translate(0.000000, -0.000000)"}
      [:path
       {:d
        "M4.45414735,7.34862126 L1.52041987,4.29475372 L4.45414735,1.24088618
        C4.69121749,0.993828342 4.66356555,0.618658038 4.39188366,0.402876222
        C4.12020177,0.187293074 3.70785701,0.212637433 3.47034993,0.459496599
        L0.161323801,3.90414407 C-0.0537746005,4.12784423
        -0.0537746005,4.4618335 0.161323801,4.68553365 L3.47038114,8.13020951
        C3.59968361,8.26442392 3.78060721,8.33333333 3.96259195,8.33333333
        C4.11498972,8.33333333 4.2680117,8.28502863 4.39188366,8.18663122
        C4.66359676,7.9708494 4.69143596,7.5956791 4.45414735,7.34862126 Z"}]
      [:path
       {:d
        "M10.5448242,3.71794872 L0.613066406,3.71794872 C0.274453125,3.71794872
        0,4.00225396 0,4.35309033 C0,4.70389634 0.274453125,4.98823194
        0.613066406,4.98823194 L10.5448242,4.98823194 C12.3253711,4.98823194
        13.7738672,6.48885491 13.7738672,8.33333333 C13.7738672,10.1778118
        12.3253711,11.6784347 10.5448242,11.6784347 L1.43050781,11.6784347
        C1.09189453,11.6784347 0.817441406,11.9627703 0.817441406,12.3135763
        C0.817441406,12.6643824 1.09189453,12.9487179 1.43050781,12.9487179
        L10.5448242,12.9487179 C13.0011914,12.9487179 15,10.878149 15,8.33333333
        C15,5.78851765 13.0013965,3.71794872 10.5448242,3.71794872 Z"}]]]]])

(defn timer []
  [:svg
   {:version "1.1", :viewBox "0 0 11 13", :height "13px", :width "11px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero", :fill "#9E9E9E"}
     [:path
      {:d
       "M9.49849568,3.86808971 L10.2888448,3.09005914 L9.51114567,2.32421068
       L8.66565908,3.1565193 C7.89327745,2.61768658 6.99196058,2.2855963
       6.04999941,2.19277928 L6.04999941,1.08285396 L7.14999822,1.08285396
       L7.14999822,0 L3.85000178,0 L3.85000178,1.08285396 L4.95000059,1.08285396
       L4.95000059,2.19277928 C4.00803942,2.2855963 3.10672255,2.61768658
       2.33434092,3.1565193 L1.48885433,2.32421068 L0.711155173,3.09005914
       L1.50150432,3.86808971 C-0.556189843,6.01278412 -0.491005685,9.38438442
       1.64809637,11.4504505 C3.78719842,13.5165165 7.21280158,13.5165165
       9.35190363,11.4504505 C11.4910057,9.38438442 11.5561898,6.01278412
       9.49849568,3.86808971 L9.49849568,3.86808971 Z M5.5,11.9113936
       C3.06994973,11.9113936 1.10000475,9.97215266 1.10000475,7.57997774
       C1.10000475,5.18780282 3.06994973,3.24856189 5.5,3.24856189
       C7.93005027,3.24856189 9.89999525,5.18780282 9.89999525,7.57997774
       C9.89726731,9.97103945 7.92891943,11.9087082 5.5,11.9113936
       L5.5,11.9113936 Z"}]
     [:path
      {:d
       "M5.5,4 L5.5,7.5 L2,7.5 C2,9.43299662 3.56700338,11 5.5,11 C7.43299662,11
       9,9.43299662 9,7.5 C9,5.56700338 7.43299662,4 5.5,4 Z"}]]]])

(defn steps []
  [:svg
   {:version "1.1", :viewBox "0 0 13 15", :height "15px", :width "13px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero", :fill "#2DA79B"}
     [:path
      {:transform
       "translate(9.331860, 5.759772) rotate(14.000000) translate(-9.331860, -5.759772) "
       :d
       "M11.1481951,6.36483734 C11.1149402,6.52326137 11.0043786,6.6711238
       10.8009626,6.62338536 C10.0689241,6.45397726 8.92184781,6.40328157
       8.24249878,6.56424039 C7.99287148,6.62338536 7.87626358,6.51692441
       7.78254537,6.22500173 C7.54889768,5.49963091 7.18007119,4.62513028
       7.25953732,3.50475554 C7.43704046,0.994896465 8.49644489,0.299943059
       9.29456123,0.345146716 C10.0926776,0.390350372 12.1436811,1.63112736
       11.1481951,6.36483734 Z M7.86503467,7.86247249 C7.86503467,7.86247249
       7.72208201,8.29803296 7.64175212,9.00735014 C7.50873273,10.1805329
       7.76656577,10.9946212 8.93782741,11.1593821 C9.92597144,11.2987953
       10.5604048,10.5721571 10.6925605,9.39897434 C10.7724585,8.69007962
       10.7793686,8.23762059 10.7793686,8.23762059 L7.86503467,7.86247249 Z"}]
     [:path
      {:transform
       "translate(2.816913, 8.987229) rotate(-8.000000) translate(-2.816913, -8.987229) "
       :d
       "M2.85419291,3.57256807 C3.6523164,3.52778674 4.71173032,4.22231995
       4.88923505,6.73218726 C4.9687019,7.85256567 4.5998721,8.72749164
       4.36622231,9.45244237 C4.27207138,9.74394354 4.15589432,9.85040483
       3.90626478,9.79168213 C3.22690967,9.63072279 2.0798231,9.68099618
       1.34777802,9.8508273 C1.14436018,9.89814343 1.03379762,9.75070298
       1.00054247,9.59227844 C0.00504753891,4.85855294 2.05650131,3.61777188
       2.85419291,3.57256807 Z M1.36894038,11.4650678 C1.36894038,11.4650678
       1.37628243,11.9175283 1.45574927,12.6264254 C1.58833797,13.799612
       2.22234515,14.5262526 3.21049804,14.386839 C4.38177017,14.2220774
       4.63960552,13.4084089 4.50658494,12.2347999 C4.42625433,11.5254804
       4.28330039,11.0899185 4.28330039,11.0899185 L1.36894038,11.4650678
       Z"}]]]])

(defn modal-close []
  [:svg
   {:version "1.1" :viewBox "0 0 20 20" :height "20px" :width "20px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero"}
     [:path
      {:fill "#B7BCBC"
       :d
       "M10,0 C4.48609375,0 0,4.48609375 0,10 C0,15.5139062 4.48609375,20 10,20
       C15.5139062,20 20,15.5139062 20,10 C20,4.48609375 15.5139062,0 10,0 Z"}]
     [:path
      {:fill "#FFFFFF"
       :d
       "M13.8827652,12.7515803 C14.0390283,12.9077699 14.0390283,13.1610482
       13.8827652,13.3172753 L13.317263,13.8828203 C13.1609998,14.0390099
       12.9077989,14.0390099 12.7515357,13.8828203 L10,11.1312963
       L7.24846425,13.8828578 C7.09220114,14.0390474 6.83900015,14.0390474
       6.68273704,13.8828578 L6.11719733,13.3172753 C5.96093422,13.1610857
       5.96093422,12.9078074 6.11719733,12.7515803 L8.8687331,9.9999812
       L6.11719733,7.24841971 C5.96093422,7.09223013 5.96093422,6.83895177
       6.11719733,6.68272469 L6.68273704,6.11714218 C6.83900015,5.96095261
       7.09220114,5.96095261 7.24846425,6.11714218 L10,8.8687037
       L12.7515357,6.11714218 C12.9077989,5.96095261 13.1609998,5.96095261
       13.317263,6.11714218 L13.8828027,6.68272469 C14.0390658,6.83891427
       14.0390658,7.09219263 13.8828027,7.24841971 L11.1312669,9.9999812
       L13.8827652,12.7515803 Z"}]]]])

(defn help []
  [:svg
   {:version "1.1" :viewBox "0 0 24 24" :height "24px" :width "24px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:stroke-width "1.375"
      :stroke "#000000"
      :transform "translate(1.000000, 1.000000)"}
     [:path
      {:stroke-linejoin "round"
       :stroke-linecap "round"
       :d
       "M8.30188679,7.99975918 C8.30216894,6.46452361 9.41123636,5.17398019
       10.8792736,5.00063618 C12.3473109,4.82729216 13.7067752,5.82635442
       14.0385634,7.32237954 C14.3703516,8.81840465 13.5687953,10.3349362
       12.1758086,10.8466814 C11.5951156,11.060012 11.2070052,11.6306536
       11.2073281,12.2706457 L11.2073281,13.2830189"}]
     [:path
      {:stroke-linejoin "round"
       :stroke-linecap "round"
       :d
       "M11.2075471,16.2924528 C11.0356095,16.2924528 10.8962264,16.4318359
       10.8962264,16.6037735 C10.8962264,16.7757113 11.0356095,16.9150943
       11.2075471,16.9150943 C11.3794849,16.9150943 11.5188679,16.7757113
       11.5188679,16.6037735 C11.5188679,16.4318359 11.3794849,16.2924528
       11.2075471,16.2924528 L11.2075471,16.2924528"}]
     [:path
      {:d
       "M0,11 C0,17.0751322 4.92486775,22 11,22 C17.0751322,22 22,17.0751322
       22,11 C22,4.92486775 17.0751322,0 11,0 C4.92486775,0 0,4.92486775 0,11
       Z"}]]]])

(defn flag []
  [:svg
   {:version "1.1", :viewBox "0 0 14 18", :height "18px", :width "14px"}
   [:g#flag
    {:fill-rule "nonzero"
     :fill "#000000"}
    [:path
     {:d
      "M1.09058123,3.03653994 C1.01550123,2.74013994 0.714261226,2.56081994
      0.417861226,2.63581994 C0.121341226,2.71097994 -0.0580187741,3.01217994
      0.0171012259,3.30865994 L3.63466123,17.5821799 C3.69822123,17.8330199
      3.92362123,18.0000199 4.17102123,18.0000199 C4.21610123,18.0000199
      4.26186123,17.9944599 4.30754123,17.9828999 C4.60390123,17.9078199
      4.78334123,17.6065399 4.70822123,17.3101399 L1.09058123,3.03653994 Z"}]
    [:path
     {:d
      "M13.1319812,7.05677994 C12.5424212,4.87985994 11.9523012,2.70309994
      11.3626212,0.526179935 C11.2987012,0.290539935 11.1866612,0.0377799351
      10.7654612,0.0124999351 C7.44994123,-0.227620065 5.27290123,3.07417994
      1.95734123,2.83401994 C1.69570123,2.80177994 1.52754123,2.93801994
      1.59142123,3.17365994 C2.18114123,5.35053994 2.76630123,7.52873994
      3.36074123,9.70429994 C3.45614123,10.0534599 3.69626123,10.1856999
      3.95798123,10.2179799 C7.27346123,10.4581399 9.45058123,7.15633994
      12.7661812,7.39649994 C13.0277812,7.42865994 13.1958612,7.29245994
      13.1319812,7.05677994 Z M10.5301412,0.834299935 C10.6927812,1.43489994
      10.8556612,2.03545994 11.0183012,2.63605994 C10.3208612,2.65901994
      9.70530123,2.79973994 9.05302123,3.04417994 C8.89042123,2.44357994
      8.72754123,1.84297994 8.56494123,1.24241994 C9.21714123,0.998059935
      9.83270123,0.857219935 10.5301412,0.834299935 Z M3.69798123,7.56789994
      C3.51290123,6.88553994 3.32814123,6.20301994 3.14326123,5.52061994
      C3.87638123,5.49937994 4.52690123,5.34049994 5.20734123,5.07153994
      C5.04454123,4.47093994 4.88182123,3.87033994 4.71918123,3.26973994
      C5.38434123,2.97241994 6.01174123,2.61645994 6.64006123,2.24881994
      C6.80270123,2.84937994 6.96558123,3.44997994 7.12826123,4.05057994
      C6.49990123,4.41817994 5.87246123,4.77425994 5.20734123,5.07153994
      C5.39226123,5.75393994 5.57710123,6.43641994 5.76198123,7.11881994
      C5.08150123,7.38773994 4.43106123,7.54661994 3.69798123,7.56789994 Z
      M6.25734123,8.94697994 C6.09218123,8.33761994 5.92710123,7.72817994
      5.76198123,7.11873994 C6.42250123,6.82365994 7.04546123,6.47069994
      7.66930123,6.10565994 C7.83442123,6.71509994 7.99954123,7.32449994
      8.16462123,7.93393994 C7.54086123,8.29901994 6.91782123,8.65189994
      6.25734123,8.94697994 Z M7.68278123,6.09781994 C7.49802123,5.41537994
      7.31310123,4.73293994 7.12826123,4.05049994 C7.75650123,3.68369994
      8.38438123,3.33269994 9.05302123,3.04421994 C9.23798123,3.72661994
      9.42286123,4.40905994 9.60770123,5.09145994 C8.93918123,5.38001994
      8.31110123,5.73097994 7.68278123,6.09781994 Z M10.1145812,6.91505994
      C9.94942123,6.30569994 9.78434123,5.69625994 9.61918123,5.08681994
      C10.2676212,4.84501994 10.8800212,4.70597994 11.5729012,4.68337994
      C11.7380612,5.29281994 11.9031812,5.90221994 12.0683412,6.51157994
      C11.3754212,6.53421994 10.7629412,6.67321994 10.1145812,6.91505994 Z"}]]])

(defn leaderboard-teams []
  [:svg
   {:version "1.1" :viewBox "0 0 20 20" :height "20px" :width "20px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g.colored
     {:stroke-width "1.25" :stroke "#000000"}
     [:path
      {:d
       "M1.875,5 C1.875,6.03553391 2.71446609,6.875 3.75,6.875 C4.78553391,6.875
       5.625,6.03553391 5.625,5 C5.625,3.96446609 4.78553391,3.125 3.75,3.125
       C2.71446609,3.125 1.875,3.96446609 1.875,5 Z"}]
     [:path
      {:d
       "M3.75,8.125 C2.02411016,8.125 0.625,9.52411016 0.625,11.25 L0.625,13.125
       L1.875,13.125 L2.5,18.125 L5,18.125"}]
     [:path
      {:d
       "M14.375,5 C14.375,6.03553391 15.2144661,6.875 16.25,6.875
       C17.2855339,6.875 18.125,6.03553391 18.125,5 C18.125,3.96446609
       17.2855339,3.125 16.25,3.125 C15.2144661,3.125 14.375,3.96446609 14.375,5
       Z"}]
     [:path
      {:d
       "M16.25,8.125 C17.9758898,8.125 19.375,9.52411016 19.375,11.25
       L19.375,13.125 L18.125,13.125 L17.5,18.125 L15,18.125"}]
     [:path
      {:d
       "M7.5,3.125 C7.5,4.50571187 8.61928813,5.625 10,5.625 C11.3807119,5.625
       12.5,4.50571187 12.5,3.125 C12.5,1.74428813 11.3807119,0.625 10,0.625
       C8.61928813,0.625 7.5,1.74428813 7.5,3.125 Z"}]
     [:path
      {:d
       "M14.375,11.25 C14.375,8.83375422 12.4162458,6.875 10,6.875
       C7.58375422,6.875 5.625,8.83375422 5.625,11.25 L5.625,13.125 L7.5,13.125
       L8.125,19.375 L11.875,19.375 L12.5,13.125 L14.375,13.125 L14.375,11.25
       Z"}]]]])

(defn leaderboard-participants []
  [:svg
   {:version "1.1" :viewBox "0 0 10 20" :height "20px" :width "10px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g.colored
     {:stroke-width "1.25" :stroke "#000000"}
     [:path
      {:d
       "M2.5,3.125 C2.5,4.50571187 3.61928813,5.625 5,5.625 C6.38071187,5.625
       7.5,4.50571187 7.5,3.125 C7.5,1.74428813 6.38071187,0.625 5,0.625
       C3.61928813,0.625 2.5,1.74428813 2.5,3.125 Z"}]
     [:path
      {:d
       "M9.375,11.25 C9.375,8.83375422 7.41624578,6.875 5,6.875
       C2.58375422,6.875 0.625,8.83375422 0.625,11.25 L0.625,13.125 L2.5,13.125
       L3.125,19.375 L6.875,19.375 L7.5,13.125 L9.375,13.125 L9.375,11.25
       Z"}]]]])

(defn next-page []
  [:svg
   {:version "1.1" :viewBox "0 0 32 32" :height "32px" :width "32px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     [:path
      {:transform
       "translate(17.000000, 16.000000) rotate(-90.000000) translate(-17.000000, -16.000000) "
       :stroke-linejoin "round"
       :stroke-linecap "round"
       :stroke-width "1.25"
       :stroke "#000000"
       :d
       "M25,12 L17.3768889,19.8392839 C17.2769811,19.9421808 17.1413916,20 17,20
       C16.8586084,20 16.7230189,19.9421808 16.6231111,19.8392839 L9,12"}]]]])

(defn prev-page []
  [:svg
   {:version "1.1" :viewBox "0 0 32 32" :height "32px" :width "32px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     [:path
      {:transform
       "translate(15.000000, 16.000000) rotate(90.000000) translate(-15.000000, -16.000000) "
       :stroke-linejoin "round"
       :stroke-linecap "round"
       :stroke-width "1.25"
       :stroke "#000000"
       :d
       "M23,12 L15.3768889,19.8392839 C15.2769811,19.9421808 15.1413916,20 15,20
       C14.8586084,20 14.7230189,19.9421808 14.6231111,19.8392839 L7,12"}]]]])

(defn send-message-all []
  [:svg {:width "24" :height "24" :viewBox "0 0 24 24"}
   [:g {:stroke "#000"
        :stroke-width "1.25"
        :fill "none"
        :fill-rule "evenodd"
        :stroke-linecap "round"
        :stroke-linejoin "round"}
    [:path {:d "M21.75 15.5v5c0 .69-.56 1.25-1.25 1.25H13c-.69 0-1.25-.56-1.25-1.25v-5"}]
    [:path {:d "M21.75 15.5c0-.69-.56-1.25-1.25-1.25H13c-.69 0-1.25.56-1.25
               1.25l4.337 2.708c.406.254.92.254 1.326 0L21.75 15.5zM4.875 5.5a2.5 2.5
               0 1 0 5 0 2.5 2.5 0 0 0-5 0zm6.453 6.246A4.376 4.376 0 0 0 3
               13.625V15.5h1.875l.625 6.25h3.75l.155-1.542m4.533-15.02a2.187 2.187 0
               1 0 4.374 0 2.187 2.187 0 0 0-4.375 0h0zm5.437 4.687a3.75 3.75 0 0
               0-6.07-.592"}]]])

(defn send-message-one []
  [:svg {:width "24" :height "24" :viewBox "0 0 24 24"}
   [:g {:stroke "#000"
        :stroke-width "1.25"
        :fill "none"
        :fill-rule "evenodd"
        :stroke-linecap "round"
        :stroke-linejoin "round"}
    [:path {:d "M9.25 16.5h-5c-.69 0-1.25-.56-1.25-1.25v-10C3 4.56 3.56 4 4.25
               4h15c.69 0 1.25.56 1.25 1.25v7.5"}]
    [:path {:d "m3.307 4.433 6.759 5.166a2.5 2.5 0 0 0 3.367 0l6.759-5.167m-3.442
               8.943 5 3.75-5 3.75V19H13c-.69 0-1.25-.56-1.25-1.25V16.5c0-.69.56-1.25
               1.25-1.25h3.75v-1.875z"}]]])

(defn message-sent []
  [:svg {:width "71"
         :height "71"
         :xmlns "http://www.w3.org/2000/svg"}
   [:g {:transform "translate(-152 -189)"
        :fill "none"
        :stroke-linecap "round"
        :stroke-linejoin "round"}
    [:g {:stroke "#34b78f"
         :stroke-width "4.333"}
     [:path {:d "m170.167 228.036 7.077 10.045a3.03 3.03 0 0 0 4.932.147l22.657-28.666"}]
     [:path {:d "M155 224.5c0 17.95 14.55 32.5 32.5 32.5s32.5-14.55
              32.5-32.5-14.55-32.5-32.5-32.5-32.5 14.55-32.5 32.5z"}]]]])

(defn copy-link []
  [:svg {:viewBox "0 0 24 24"
         :height "24"
         :width "24"}
   [:g {:stroke-linejoin "round"
        :stroke-linecap "round"
        :fill-rule "evenodd"
        :fill "none"
        :stroke-width "1.25"
        :stroke "#122020"}
    [:path {:d "m10.178 17.5-.776.778a3.75 3.75 0 0 1-5.304-5.304l3.978-3.978a3.75 3.75 0 0 1 5.687 4.854"}]
    [:path {:d "m14.723 6.723.625-.625a3.75 3.75 0 1 1 5.304 5.304l-3.978 3.977a3.75 3.75 0 0 1-5.686-4.855"}]]])

(defn share-email []
  [:svg {:viewBox "0 0 24 24"
         :height "24"
         :width "24"}
   [:g {:stroke-linejoin "round"
        :stroke-linecap "round"
        :fill-rule "evenodd"
        :fill "none"
        :stroke-width "1.25"
        :stroke "#000"}
    [:path {:d "M11.75 17.375a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0zM18 19.875a1.875
               1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0h0zM18 13.625a1.875 1.875 0 1 0 3.75 0
               1.875 1.875 0 0 0-3.75 0h0zM15.229 16.412l3.042-1.824M15.365 18.071l2.77 1.108M9.875
               15.5H4.25c-.69 0-1.25-.56-1.25-1.25v-10C3 3.56 3.56 3 4.25 3h15c.69 0 1.25.56 1.25 1.25v5"}]
    [:path {:d "m20.218 3.458-6.787 5.22c-.991.763-2.37.763-3.362 0l-6.787-5.22"}]]])

(defn share-whatsapp []
  [:svg {:viewBox "0 0 24 24"
         :height "24"
         :width "24"}
   [:path {:stroke-linejoin "round"
           :stroke-linecap "round"
           :fill-rule "evenodd"
           :fill "none"
           :stroke-width "1.25"
           :stroke "#122020"
           :d "M12.383 3A9.35 9.35 0 0 0 3 12.3a9.167 9.167 0 0 0 1.783 5.45l-1.166
                            3.458 3.6-1.141A9.383 9.383 0 0 0 21.75 12.3 9.35 9.35 0 0 0 12.383
                            3m5.059 11.592c-.059-.1-.225-.167-.467-.284-.242-.116-1.45-.708-1.667
                            -.791-.216-.084-.391-.125-.55.125a7.38 7.38 0 0 1-.558.766c-.142.159-.283.184-.533.059a7.667
                            7.667 0 0 1-3.45-2.984c-.142-.241 0-.375.108-.491.408-.409.417-.35.517-.55a.442.442 0 0 0
                            0-.425c-.125-.142-.584-1.325-.792-1.809-.208-.483-1.258-.575-1.667-.125-4.333 4.567 6.225
                            12.392 8.925 7.625.226-.32.276-.734.134-1.1"}]])

(defn tick []
  [:svg {:viewBox "0 0 24 24"
         :height "24px"
         :width "24px"}
   [:g {:fill-rule "evenodd"
        :fill "none"
        :stroke-width "1"
        :stroke "none"}
    [:path {:fill-rule "nonzero"
            :fill "#34b78f"
            :d "M17.7914954,7.20593567 C18.0763118,6.92287737 18.5284701,6.93285407
                       18.8014192,7.22821925 C19.0743682,7.52358443 19.0647479,7.99248931
                       18.7799314,8.2755476 L18.7799314,8.2755476 L10.2085046,16.7940643
                       C10.0137722,16.9875947 9.74081372,17.0441423 9.50039032,16.966151
                       C9.23241011,17.0540925 8.92805797,16.9708848 8.73697594,16.7301212
                       L8.73697594,16.7301212 L5.16557295,12.2301494 C4.91302899,11.9119437
                       4.95397446,11.4390232 5.25702721,11.1738518 C5.56007997,10.9086804
                       6.0104801,10.9516731 6.26302406,11.2698788 L6.26302406,11.2698788 L9.543,15.403 Z"}]]])

(defn home []
  [:svg {:width "20"
         :height "20"
         :viewBox "0 0 20 20"
         :fill "none"
         :xmlns "http://www.w3.org/2000/svg"}
   [:path {:d "M7.50008 17.5V11.3333C7.50008 10.8666 7.50008 10.6333 7.59091 10.455
            C7.67081 10.2982 7.79829 10.1707 7.95509 10.0908C8.13335 10 8.36671 10 8.83342 10
            H11.1668C11.6335 10 11.8668 10 12.0451 10.0908C12.2019 10.1707 12.3294 10.2982
            12.4093 10.455C12.5001 10.6333 12.5001 10.8666 12.5001 11.3333V17.5M1.66675 7.91667
            L9.20008 2.26667C9.48697 2.0515 9.63041 1.94392 9.78795 1.90245C9.927 1.86585
            10.0732 1.86585 10.2122 1.90245C10.3698 1.94392 10.5132 2.05151 10.8001 2.26667
            L18.3334 7.91667M3.33342 6.66667V14.8333C3.33342 15.7668 3.33342 16.2335 3.51507 16.59
            C3.67486 16.9036 3.92983 17.1586 4.24343 17.3183C4.59995 17.5 5.06666 17.5 6.00008 17.5
            H14.0001C14.9335 17.5 15.4002 17.5 15.7567 17.3183C16.0703 17.1586 16.3253 16.9036
            16.4851 16.59C16.6668 16.2335 16.6668 15.7668 16.6668 14.8333V6.66667L11.6001 2.86667
            C11.0263 2.43634 10.7394 2.22118 10.4244 2.13824C10.1462 2.06503 9.85392 2.06503
            9.57581 2.13824C9.26073 2.22118 8.97385 2.43634 8.40008 2.86667L3.33342 6.66667Z"
           :stroke "black"
           :stroke-linecap "round"
           :stroke-linejoin "round"}]])
